import { cx } from "../../utils/cx";
import Spinner from "./Spinner";

const SIZES = {
  sm: "h-9 px-4 text-sm",
  md: "h-11 px-6 text-sm",
  lg: "h-[52px] px-8 text-base",
  icon: "h-9 w-9 p-0",
};

const VARIANTS = {
  solid: "bg-brand text-white hover:bg-brand/90 active:bg-brand/80 shadow-sm hover:shadow-md",
  outline: "border-2 border-brand bg-transparent text-brand hover:bg-brand/5 active:bg-brand/10",
  ghost: "bg-transparent text-brand hover:bg-brand/10 active:bg-brand/20",
  soft: "bg-brand/10 text-brand hover:bg-brand/20 active:bg-brand/30",
  danger: "bg-red-600 text-white hover:bg-red-600/90 active:bg-red-700 shadow-sm hover:shadow-md",
  "danger-soft": "bg-red-50 text-red-600 hover:bg-red-100 active:bg-red-200",
};

export default function Button({
  children,
  type = "button",
  variant = "solid",
  size = "md",
  loading = false,
  disabled = false,
  icon,
  iconPosition = "left",
  fullWidth = false,
  className,
  ...props
}) {
  return (
    <button
      type={type}
      disabled={disabled || loading}
      className={cx(
        "inline-flex shrink-0 items-center justify-center gap-2 rounded-lg font-medium outline-none transition-all duration-200",
        "focus-visible:ring-2 focus-visible:ring-brand/20 focus-visible:ring-offset-2",
        "disabled:cursor-not-allowed disabled:opacity-50",
        // Width first, so the icon size's fixed width wins over w-fit
        fullWidth ? "w-full" : "w-fit",
        SIZES[size],
        VARIANTS[variant],
        className
      )}
      {...props}
    >
      {loading ? <Spinner className="h-4 w-4" /> : iconPosition === "left" && icon}
      {children}
      {!loading && iconPosition === "right" && icon}
    </button>
  );
}
